import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocationProvider } from "./context/location-context";
import { initGA, useAnalytics } from "./hooks/useAnalytics";

import HomePage2 from "./pages/HomePage";
import DiscoverPage from "./pages/DiscoverPage";

import OTPVerification from "./pages/OtpVerification";
import UsernameRegistration from "./pages/UsernameRegistration";
import { useEffect } from "react";
import CategoryTabs from "./pages/ClassFieldsPage";
import ProfilePage from "./pages/ProfilePage";
import ScoopsPage from "./pages/ScoopsPage";
import SigninPage from "./Signin";
import DiscoverMap from "./pages/DiscoverMap";
import Custom404 from "./pages/404";
import BusinessPage from "./pages/Business";
import NewsPage from "./pages/NewsPage";
import NewsnewPage from "./pages/NewsnewPage";
import LandingPage from "./pages/LandingPage";
import DemoPage from "./pages/EventsPage";
import ExploreMore from "./pages/MorePage";
import PrivacyPolicy from "./pages/PrivacyPage";
import TermsAndConditions from "./pages/TOC";
import ChildSafetyPolicy from "./pages/ChildSafetyPage";

import GroupsPage from "./pages/GroupsPage";
import GroupDetailPage from "./pages/GroupDetailPage";
import CreateGroupPage from "./pages/CreateGroupPage";
import EventDetails from "./pages/EventDetailPage";
import ContactPage from "./pages/ContactPage";
import ChatOnboarding from "./pages/ChatOnboarding";
import SayHello from "./pages/SayHello";
import MainLayout from "./components/MainLayout";
import ChatDetail from "./pages/ChatDetail";
import ChatPage from "./pages/ChatPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import SinglePostPage from "./pages/SinglePostPage.";
import ArticleWriter from "./pages/GallyonomicsEditor";
import ArticleDetailPage from "./pages/GallyonomicsDetailsPage";
import GallynomicsMainPage from "./pages/GallionomicsPage";
import HighSchoolersPage from "./pages/HighSchoolerPage";
import Test from "./pages/Test";

function AnalyticsWrapper({ children }) {
  useAnalytics();
  return children;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);
  return (
    <LocationProvider>
      <Router>
        <AnalyticsWrapper>
          <ToastContainer />
          <Routes>
            <Route path="/test" element={<Test />} />
            <Route path="/home" element={<HomePage2 />} />
            <Route path="/discover" element={<DiscoverPage />} />
            <Route path="/signin" element={<SigninPage />} />
            <Route path="/account/delete" element={<DeleteAccountPage />} />
            <Route path="/discovermap" element={<DiscoverMap />} />

            <Route path="/otpverification" element={<OTPVerification />} />
            <Route path="/register-user" element={<UsernameRegistration />} />
            <Route path="/classifieds" element={<CategoryTabs />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/scoops" element={<ScoopsPage />} />
            <Route path="*" element={<Custom404 mode="404" />} />
            <Route
              path="/business/:slug/:google_place_id"
              element={<BusinessPage />}
            />
            <Route path="/news" element={<NewsnewPage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/events" element={<DemoPage />} />
            <Route path="/more" element={<ExploreMore />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/toc" element={<TermsAndConditions />} />
            <Route path="/child-safety" element={<ChildSafetyPolicy />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/groups/:id" element={<GroupDetailPage />} />
            <Route path="/groups/create" element={<CreateGroupPage />} />

            <Route
              path="/eventdetail/:category/:slug/:id"
              element={<EventDetails />}
            />
            <Route path="/contact" element={<ContactPage />} />
            <Route
              path="/makeyaari-onboarding"
              element={
                <MainLayout rs={false} pad={false} isMobilePadding={false}>
                  <ChatOnboarding />
                </MainLayout>
              }
            />
            <Route path="/makeyaari" element={<SayHello />} />
            <Route path="/makeyaarichat" element={<ChatPage />} />
            <Route
              path="/chatdetail"
              element={
                <MainLayout rs={false} pad={false} isMobilePadding={false}>
                  <ChatDetail />
                </MainLayout>
              }
            />
            <Route path="/post/:id" element={<SinglePostPage />} />
            <Route
              path="/gallionomics/editor"
              element={
                <MainLayout rs={false}>
                  <ArticleWriter />
                </MainLayout>
              }
            />
            <Route
              path="/gallionomics/details/:category/:articleSlug/:id"
              element={
                <MainLayout rs={false}>
                  <ArticleDetailPage />
                </MainLayout>
              }
            />
            <Route
              path="/gallionomics"
              element={
                <MainLayout rs={false}>
                  <GallynomicsMainPage />
                </MainLayout>
              }
            />
            <Route
              path="/parents/highschoolers"
              element={
                <MainLayout rs={false}>
                  <HighSchoolersPage />
                </MainLayout>
              }
            />
          </Routes>

          <ToastContainer />
        </AnalyticsWrapper>
      </Router>
    </LocationProvider>
  );
}

export default App;
